import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e66ae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "tabbar" }
const _hoisted_3 = { class: "back" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Back", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, " 페르소나 설정(복사) ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrap_chat_screen" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "room_info" }, [
      /*#__PURE__*/_createElementVNode("div", null, "설정을 시작합니다")
    ]),
    /*#__PURE__*/_createElementVNode("pre", null, [
      /*#__PURE__*/_createTextVNode("      "),
      /*#__PURE__*/_createElementVNode("code", null, "\n      [\n          0: {\n              \"role\": \"user\",\n              \"content\": \"start\"\n          }\n      ]\n      "),
      /*#__PURE__*/_createTextVNode("\n      ")
    ])
  ])
], -1))
const _hoisted_7 = { class: "wrap_input_screen" }
const _hoisted_8 = { class: "wrap_input" }
const _hoisted_9 = ["onKeydown"]
const _hoisted_10 = {
  key: 0,
  class: "button_rec"
}
const _hoisted_11 = {
  key: 1,
  class: "button_rec"
}

import { ref } from 'vue';
import { pushPage } from '@utils/route.helper';
import { errorType } from '@interface/error';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonaCopy',
  setup(__props) {

const isListening = ref(false);
const message = ref('');
const sendMessage = () => {
  console.log('sending messages', message);
};

const handleEnterKey = () => {
  sendMessage();
  message.value = '';
};

const handleShiftEnterKey = (event: any) => {
  if (event.shiftKey) {
    // 쉬프트 키를 누르면서 엔터 키를 눌렀을 때
    message.value += '\n'; // 또는 다른 줄바꿈 처리 방법을 사용할 수 있습니다.
  } else {
    // 쉬프트 키 없이 엔터 키만 눌렀을 때
    handleEnterKey();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          class: "chevron",
          icon: "fa-solid fa-chevron-left"
        }),
        _hoisted_4
      ]),
      _hoisted_5,
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars"
      })
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
          class: "input",
          placeholder: "Message",
          onKeydown: _withKeys(_withModifiers(handleShiftEnterKey, ["exact","prevent"]), ["enter"])
        }, null, 40, _hoisted_9), [
          [_vModelText, message.value]
        ]),
        (isListening.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-microphone" })
            ]))
          : _createCommentVNode("", true),
        (!isListening.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-square" })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})